import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IconComponent, ButtonComponent, FieldComponent, FieldInputDirective, FieldHintComponent } from '@kin/spark-ui';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, IconComponent, ButtonComponent, FieldComponent, FieldInputDirective, FieldHintComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent {
  private router = inject(Router);
  private auth = inject(AuthService);

  email = '';
  sending = false;
  error = '';

  onEmailInput(event: Event) {
    this.email = (event.target as HTMLInputElement).value;
    this.error = '';
  }

  continue() {
    const email = this.email.trim().toLowerCase();
    if (!email || this.sending) return;

    this.sending = true;
    this.error = '';

    this.auth.sendOtp(email).subscribe({
      next: () => {
        this.sending = false;
        this.router.navigate(['/verify'], { state: { email } });
      },
      error: () => {
        this.sending = false;
        this.error = 'Unable to send code. Please check your email and try again.';
      },
    });
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') this.continue();
  }
}
